import { render } from "./list_departments.vue?vue&type=template&id=a95e771e&lang=html"
import script from "./list_departments.vue?vue&type=script&lang=js"
export * from "./list_departments.vue?vue&type=script&lang=js"

import "./list_departments.vue?vue&type=style&index=0&id=a95e771e&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__